import { getTaskById, getListById, getListByTaskId } from '@/utils/board'

const state = {
	lists: [],
	labels: []
}

const getters = {
	getListById: state => listId => {
		return getListById(state.lists, listId)
	},
	getListByTaskId: state => taskId => {
		return getListByTaskId(state.lists, taskId)
	},
	getTaskById: state => taskId => {
		return getTaskById(state.lists, taskId)
	}
}

const mutations = {
	setLists (state, value) {
		state.lists = value
	},
	addList (state, list) {
		state.lists.push(list)
	},
	setLabels (state, value) {
		state.labels = value
	},
	moveList (state, [fromIndex, toIndex]) {
		state.lists.splice(toIndex, 0, state.lists.splice(fromIndex, 1)[0])
	},
	updateList (state, { id, ...others }) {
		let list = getListById(state.lists, id)
		if (list) {
			state.lists[state.lists.indexOf(list)] = { id, ...others }
			state.lists = JSON.parse(JSON.stringify(state.lists))
		}
	},
	removeList (state, { listId }) {
		const index = state.lists.findIndex(list => list.id === listId)
		state.lists.splice(index, 1)
	},
	addTask (state, task) {
		const list = getListById(state.lists, task.taskListId)
		list.tasks.push(task)
	},
	updateTask (state, task) {
		let list = getListByTaskId(state.lists, task.id)
		if (list) {
			let index = list.tasks.findIndex((t) => t.id === task.id)
			list.tasks[index] = task
		}
	},
	moveTask (state, [fromListRef, fromIndex, toListRef, toIndex]) {
		const fromList = typeof fromListRef === 'number'
			? state.lists[fromListRef].tasks
			: getListById(state.lists, fromListRef)
		const toList = typeof toListRef === 'number'
			? state.lists[toListRef].tasks
			: getListById(state.lists, toListRef)
		toList.splice(toIndex, 0, fromList.splice(fromIndex, 1)[0])
	},
	removeTask (state, { taskId }) {
		const list = getListByTaskId(state.lists, taskId)
		list.tasks.splice(list.tasks.findIndex(task => task.id === taskId), 1)
	},
	updateTasksMembers (state, members) {
		try {
			state.lists.map(list => {
				list.tasks.map(task => {
					task.task_Members = task.task_Members.filter(member => {
						let isHere = members.find(_member => {
							return parseInt(_member.id) === parseInt(member.userId)
						})
						return isHere
					})
					return task
				})
				return list
			})

			state.lists = JSON.parse(JSON.stringify(state.lists))
		} catch (error) {
			console.log(error)
		}
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	getters
}



// WEBPACK FOOTER //
// ./src/store/modules/TaskManagerBoard.js